import { useMemo } from "react";

import useVehicleLookupConfig from "../data/useVehicleLookupConfig";

/**
 * Which identifier this yard's vehicles are keyed by and whether lookups are asynchronous. The
 * precedent is useFeatureFlag over useCustomerDetails; this reads the lookup config instead,
 * because the mode is a capability the API reports, not a feature flag.
 */
export const useVehicleLookupMode = () => {
  const { lookupConfig, config } = useVehicleLookupConfig();

  return useMemo(
    () => ({
      ...lookupConfig,
      isVinMode: lookupConfig.identifierType === "Vin",
      isAsync: lookupConfig.asynchronous,
      isLoading: config.isLoading,
    }),
    [lookupConfig, config.isLoading]
  );
};

export default useVehicleLookupMode;
